// @flow

// Libs
export default (state: Object): number => state.mapModule.isPreviousPointsShown
